import Helper from "./Helper";

class Dropdowntoggler {
  constructor(config = {}) {
    const {
      dropdownWrapperSelector,
      dropdownToggleSelector,
      dropdownDropSelector,
      needsBackdrop,
      externalCall
    } = config;

    this.dropdownWrapperSelector = dropdownWrapperSelector;
    this.dropdownToggleSelector = dropdownToggleSelector;
    this.dropdownDropSelector = dropdownDropSelector;
    this.needsBackdrop = needsBackdrop;
    this.externalCall = externalCall || false;

    this.body = document.querySelector("body");

    this.dropdowns = Array.prototype.slice.call(
      document.querySelectorAll(this.dropdownWrapperSelector)
    );

    if (this.dropdowns.length > 0 && !externalCall) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.dropdowns.forEach((dd, i) => {
      const toggle = dd.querySelector(this.dropdownToggleSelector);
      if(toggle){
        toggle.addEventListener("click", e => {
          if(Helper.hasClass(toggle, 'active')){
            this.closeAllDropdowns();
          } else {
            this.openDropdown(dd);
          }
        });

        dd.querySelectorAll(this.dropdownDropSelector + ' a').forEach((link, j) => {
          link.addEventListener("click", e => {
            if(Helper.hasClass(toggle, 'active')){
              this.closeAllDropdowns();
            }
          });
        });
      }
    });
  }

  openDropdown(dropdown) {
    const toggle = dropdown.querySelector(this.dropdownToggleSelector);
    const drop = dropdown.querySelector(this.dropdownDropSelector);
    Helper.addClass(dropdown, "active");
    Helper.addClass(toggle, "active");
    Helper.addClass(drop, "active");
    this.dropdowns.forEach((dd, i) => {
      if (dd != dropdown) {
        const toggle = dd.querySelector(this.dropdownToggleSelector);
        const drop = dd.querySelector(this.dropdownDropSelector);
        Helper.removeClass(dd, "active");
        Helper.removeClass(toggle, "active");
        Helper.removeClass(drop, "active");
      }
    });

    if(!document.querySelector('.dropdown-backdrop') && this.needsBackdrop){
      let backdrop = document.createElement('div');
      Helper.addClass(backdrop, 'dropdown-backdrop');
      this.body.appendChild(backdrop);
      backdrop.addEventListener('click', () => {
        this.closeAllDropdowns();
      });
    }
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((dd, i) => {
      const toggle = dd.querySelector(this.dropdownToggleSelector);
      const drop = dd.querySelector(this.dropdownDropSelector);
      Helper.removeClass(dd, "active");
      Helper.removeClass(toggle, "active");
      Helper.removeClass(drop, "active");
    });

    if(document.querySelector('.dropdown-backdrop') && this.needsBackdrop){
      document.querySelector('.dropdown-backdrop').remove();
    }
  }
}
export default Dropdowntoggler;
